// Activa Axios antes de renderizar
import "./api/axiosSetup";

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./index.css";

// --- Helpers ---
async function clearSWAndCaches() {
  if ("serviceWorker" in navigator) {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map((r) => r.unregister()));
  }
  if (window.caches) {
    const names = await caches.keys();
    await Promise.all(names.map((n) => caches.delete(n)));
  }
}

async function coldResetOnce(tag = "v1") {
  const KEY = `cold_reset_${tag}`;
  if (!localStorage.getItem(KEY)) {
    await clearSWAndCaches();
    localStorage.setItem(KEY, "true");
  }
}

async function autoUpdateOnStart() {
  try {
    const res = await fetch("/version.json", { cache: "no-store" });
    if (!res.ok) return;
    const { version } = await res.json();

    const LAST_KEY = "last_seen_version";
    const last = localStorage.getItem(LAST_KEY);

    if (!last) {
      localStorage.setItem(LAST_KEY, version);
      return;
    }

    if (last !== version) {
      // Guarda primero para evitar bucles tras la recarga
      localStorage.setItem(LAST_KEY, version);
      await clearSWAndCaches(); // limpia SW + CacheStorage
      // Recarga con cache-busting del HTML
      window.location.replace(window.location.pathname + `?v=${Date.now()}`);
    }
  } catch {
    // silencio: si falla la consulta, no bloquea el arranque
  }
}

// --- Bootstrap + Render ---
(async function bootstrap() {
  // 1) Limpieza en frío (solo 1 vez global)
  await coldResetOnce("v1"); // si alguna vez necesitas forzar de nuevo, cambia a "v2"

  // 2) Autochequeo de versión (solo limpia/recarga si cambió)
  await autoUpdateOnStart();

  // 3) Monta la app
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <Router>
        <App />
      </Router>
    </React.StrictMode>
  );
})();
